import { createSelector } from "@reduxjs/toolkit";

import { initialState } from "./slice";

// First select the relevant part from the state
const selectDomain = (state) => state.booking || initialState;

export const selectTestCategories = createSelector([selectDomain], (state) => {
  const catalog = state.catalog;
  const testCategories = {};
  catalog.forEach((item) => {
    const test = item.test;
    const testCategory = test.testCategory;
    if (!testCategories[testCategory._id]) {
      testCategories[testCategory._id] = {
        _id: testCategory._id,
        name: testCategory.name,
        tests: [],
      };
    }

    let obj = { ...test };
    obj._id = item._id;
    obj.price = item.price;
    testCategories[testCategory._id].tests.push(obj);
  });

  return testCategories;
});

/*export const selectCommodities = createSelector([selectDomain], (state) => {
  const catalog = state.catalog;
  const options = [];
  catalog.forEach((item) => {
    const test = item.test;
    const commodity = test.commodity;
    const commodityCategory = test.commodityCategory;

    const index = options.findIndex(
      (opt) => opt.label === commodityCategory.name
    );
    const commodityOption = { label: commodity.name, value: commodity._id };
    if (index === -1) {
      options.push({
        label: commodityCategory.name,
        options: [commodityOption],
      });
    } else {
      // check if commodity already exists in category
      const optIndex = options[index].options.findIndex(
        (cat) => cat.value === commodity._id
      );
      if (optIndex === -1) {
        options[index].options.push(commodityOption);
      }
    }
  });
  return options;
});*/

export const selectCommodities = createSelector(
  [selectDomain],
  (state) => state.commodities
);

export const selectTests = createSelector(
  [selectDomain],
  (state) => state.tests
);

export const selectError = createSelector(
  [selectDomain],
  (state) => state.error
);
